import React from "react";

const TargetIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#C8D2DB" />
      <path
        d="M16 18.2223C17.2273 18.2223 18.2222 17.2274 18.2222 16.0001C18.2222 14.7728 17.2273 13.7778 16 13.7778C14.7727 13.7778 13.7778 14.7728 13.7778 16.0001C13.7778 17.2274 14.7727 18.2223 16 18.2223Z"
        fill="#002035"
      />
      <path
        d="M16 23.5C20.1421 23.5 23.5 20.1421 23.5 16C23.5 11.8579 20.1421 8.5 16 8.5C11.8579 8.5 8.5 11.8579 8.5 16C8.5 20.1421 11.8579 23.5 16 23.5Z"
        stroke="#002035"
        strokeWidth="3"
      />
    </svg>
  );
};

export default TargetIcon;
